<template>
  <b-button @click="$emit('click', $event)" size="sm" variant="primary" v-b-tooltip.hover :title="showToolTip ? 'Коррекция показаний' : ''"><i class="fa fa-calculator"></i></b-button>
</template>

<script>

export default ({
  name: "button-corection",
  computed: {
    showToolTip() {
      return this.$store.state.userSettings.showTooltips;
    }
  }
})
</script>
